
// ====================================================
//  Global Header
// ====================================================

// ヘッダー追従関数（上スクロール時、ページ最下部到達時のみ表示）
function headerScrollFunc(id) {
    'use strict';

    // 追従ヘッダー取得
    const header = document.getElementById(id);

    // 初期設定（定数）
    const scrollOptions = {
    fixClass: 'is-fix',  // 追従class
    hideClass: 'is-hide',  // 追従中 非表示class
    showClass: 'is-show',  // 追従中 表示class
    showDelay: 500 // 表示するまでのディレイ時間（指定秒数（ミリ秒）以上、下スクロールしなければ表示）
    };

    // 動的状態管理
    let state = {
    startPosi: 0,
    upFlg: false,
    setTimeoutFlg: false,
    setTimeoutId: 0
    };

    // ヘッダーが存在するかチェック
    if (!header) return;

    // パフォーマンス向上のためのフラグ
    let ticking = false;

    // スクロールとリサイズイベントリスナーの追加
    window.addEventListener('resize', () => {
    headerFix(scrollOptions, state);
    });

    window.addEventListener('scroll', () => {
    if (!ticking) {
        window.requestAnimationFrame(() => {
        headerFix(scrollOptions, state);
        ticking = false;
        });
        ticking = true;
    }
    });

    // 追従設定
    function headerFix(options, state) {
    const headerBasePosi = 0;
    const headerFixPosi = header.clientHeight;

    const scrollTop = getScrollTop();

    if (scrollTop > state.startPosi) {
        handleScrollDown(options, state, scrollTop, headerFixPosi);
    } else {
        handleScrollUp(options, state, scrollTop, headerBasePosi);
    }

    state.startPosi = scrollTop; // スクロール開始位置を更新
    }

    // 下スクロール時の処理
    function handleScrollDown(options, state, scrollTop, headerFixPosi) {
    state.upFlg = false;

    clearTimeout(state.setTimeoutId);
    state.setTimeoutFlg = false;

    if (scrollTop > headerFixPosi) {
        header.classList.add(options.fixClass);
    }

    const pageHeight = getPageHeight();
    const scrollBottom = window.innerHeight + scrollTop;

    if (pageHeight <= scrollBottom) {
        headerShow(options);
    } else if (header.classList.contains(options.showClass)) {
        headerHide(options);
    }
    }

    // 上スクロール時の処理
    function handleScrollUp(options, state, scrollTop, headerBasePosi) {
    state.upFlg = true;

    if (scrollTop <= headerBasePosi) {
        header.classList.remove(options.fixClass, options.showClass, options.hideClass);
    } else if (!state.setTimeoutFlg) {
        state.setTimeoutFlg = true;
        state.setTimeoutId = setTimeout(() => {
        if (state.upFlg && header.classList.contains(options.fixClass)) {
            headerShow(options);
        }
        }, options.showDelay);
    }
    }

    // 追従ヘッダー表示関数
    function headerShow(options) {
    header.classList.remove(options.hideClass);
    header.classList.add(options.showClass);
    }

    // 追従ヘッダー非表示関数
    function headerHide(options) {
    header.classList.remove(options.showClass);
    header.classList.add(options.hideClass);
    }

    // ヘルパー関数
    function getScrollTop() {
    return window.pageYOffset || document.documentElement.scrollTop;
    }

    function getPageHeight() {
    return document.documentElement.scrollHeight || document.body.scrollHeight;
    }
}

// ====================================================
//  set EventListener
// ====================================================

// Global Header - scrollview

window.addEventListener('load',function(){
    headerScrollFunc("js-header");
})

// DrawerMenu setting

document.addEventListener("DOMContentLoaded", function() {
    const drawerMenuOpener = document.getElementById("DrawerMenuOpener");
    const drawerMenu = document.getElementById("DrawerMenu");
    
    // メニューを開閉する関数
    function toggleDrawerMenu() {
        drawerMenu.classList.toggle("open");  // openクラスを付与/削除

        if (drawerMenu.classList.contains("open")) {
            document.body.classList.add("drawer-open");  // スクロールを無効化
        } else {
            document.body.classList.remove("drawer-open");  // スクロールを有効化
        }
    }
    
    // メニューオープナーにクリックイベントを追加
    drawerMenuOpener.addEventListener("click", toggleDrawerMenu);
    
    // ドロワーメニュー内の「閉じる」ボタンにイベントリスナーを追加
    const closeButton = document.getElementById("DrawerMenuClose");
    if (closeButton) {
        closeButton.addEventListener("click", toggleDrawerMenu);
    }
});
